import classnames from 'classnames';
import React from 'react';

import {
  ANALYTICS_VIEWS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEW_FEATURE_LOCATIONS
} from 'dpl/constants/analytics';
import MediaGrid from 'dpl/components/MediaGrid';

import { usePuppyData } from '../../hooks/usePuppyData';
import AboutPuppy from '../AboutPuppy';
import SummaryDetails from './SummaryDetails';
import SummaryDetailsSheet from './SummaryDetailsSheet';

const COMMON_ANALYTICS_PROPS = {
  view: ANALYTICS_VIEWS.PUPPY_PROFILE,
  view_feature: ANALYTICS_VIEW_FEATURES.REQUEST_INFO_BUTTON
};

export default function PuppyDetails() {
  const { puppy } = usePuppyData();

  return (
    <section className="PuppyDetails container-xxl mt4 mt10-md font-16">
      <div className="row slim-gutters">
        <div className="col-lg-8">
          <MediaGrid gallery={puppy.gallery} />
          <div className="dn db-m dn-l">
            <SummaryDetails
              className="mt8"
              analytics={{
                ...COMMON_ANALYTICS_PROPS,
                view_feature_location:
                  ANALYTICS_VIEW_FEATURE_LOCATIONS.PUPPY_DETAILS
              }}
            />
          </div>
          <div className="row">
            <div className="col-lg-10">
              <AboutPuppy />
            </div>
          </div>
        </div>
        <div className="col-lg-4 dn db-l">
          <SummaryDetails
            className={classnames('mb10', {
              'sticky top-5': !puppy.reserved
            })}
            analytics={{
              ...COMMON_ANALYTICS_PROPS,
              view_feature_location:
                ANALYTICS_VIEW_FEATURE_LOCATIONS.PUPPY_DETAILS_STICKY_SIDE
            }}
          />
        </div>
      </div>
      {!puppy.reserved && (
        <SummaryDetailsSheet
          className="dn-ns"
          analytics={{
            ...COMMON_ANALYTICS_PROPS,
            view_feature_location:
              ANALYTICS_VIEW_FEATURE_LOCATIONS.STICKY_BOTTOM
          }}
        />
      )}
    </section>
  );
}
